import messages from './messages';

/** Get translations based on locale */
export const getIntlMessages = (
  locale: string,
  defaultLocale = 'da'
): typeof messages.en => {
  if (messages[locale]) return messages[locale];

  // e.g. from 'en-US' to 'en'
  const shortLocale = locale.slice(0, locale.indexOf('-'));
  return messages[shortLocale] || messages[defaultLocale];
};
